<template>
  <div
    class="d-flex justify-content-center align-items-center gap-3 rounded-4 p-3 w-100 cs-list-guide"
    style="background: #c0c0c0"
  >
    <div class="w-fit item-guide">
      <img
        v-if="this.type == 0"
        src="@/static/eSim/cmnd/cmnd-front-1.png"
        alt="image"
        class="cs-image-font mb-2"
      />
      <img
        v-if="this.type == 1"
        src="@/static/eSim/passport/passport-1.png"
        alt="image"
        class="cs-image-font mb-2"
      />
      <p class="font-size-10 w-100 text-center mb-0">
        {{ $t("esim_display_all_corners") }}
      </p>
    </div>
    <div class="w-fit item-guide">
      <img
        v-if="this.type == 0"
        src="@/static/eSim/cmnd/cmnd-front-2.png"
        alt="image"
        class="cs-image-font mb-2"
      />
      <img
        v-if="this.type == 1"
        src="@/static/eSim/passport/passport-2.png"
        alt="image"
        class="cs-image-font mb-2"
      />
      <p class="font-size-10 w-100 text-center mb-0">
        {{ $t("esim_photos_must_be_clear") }}
      </p>
    </div>
    <div class="w-fit item-guide">
      <img
        v-if="this.type == 0"
        src="@/static/eSim/cmnd/cmnd-front-3.png"
        alt="image"
        class="cs-image-font mb-2"
      />
      <img
        v-if="this.type == 1"
        src="@/static/eSim/passport/passport-3.png"
        alt="image"
        class="cs-image-font mb-2"
      />
      <p class="font-size-10 w-100 text-center mb-0">
        {{ $t("esim_no_light_dazzle") }}
      </p>
    </div>
  </div>
</template>
<script>
import { Image } from "vant";
export default {
  name: "Guide Capture",
  props: {
    type: {
      type: Number,
      required: 0,
    },
  },
  components: {
    [Image.name]: Image,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.cs-image-font {
  width: 74px;
  height: auto;
  border-radius: 8px;
  position: relative;
  left: 15px;
}

.item-guide p {
  width: auto;
}

@media (min-width: 376px) {
  .cs-list-guide {
    margin: 30px 0 !important;
  }
}
</style>